import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=934787b4"
import script from "./ResourceModal.vue?vue&type=script&lang=js"
export * from "./ResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports